export default "__VITE_ASSET__b3547ca8__"